import { countryListDeCh } from './countryListDeCH';
import { countryListEn } from './countryListEn';

interface CountrySelectionProps {
  register?: any;
  id: string;
  label: string | JSX.Element;
  error?: any;
  defaultValue?: string;
  disabled?: boolean;
  locale: string;
}

function CountrySelection({
  register,
  id,
  label,
  error,
  disabled,
  defaultValue = 'CH',
  locale,
}: CountrySelectionProps) {
  const countryList = locale === 'de' ? countryListDeCh : countryListEn;
  return (
    <div className="mt-2 grid grid-cols-6 gap-x-2 gap-y-2 lg:gap-x-4">
      <label
        htmlFor={id}
        className="col-span-2 pt-1 text-base-m font-light lg:text-base-d"
      >
        {label}
      </label>
      <select
        {...register}
        className={`col-span-6 block w-full border-0 border-b-2 border-secondary bg-transparent focus:border-primary focus:ring-0 focus-visible:outline-none lg:col-span-4 ${
          error ? 'border-red-500' : ''
        }`}
        disabled={disabled}
        defaultValue={defaultValue}
      >
        {Object.keys(countryList).map((key) => {
          return (
            <option key={key} value={key}>
              {countryList[key]}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default CountrySelection;
